export const hexToRgb = (hex: string): string => {
    const bigint = parseInt(hex.replace('0x', ''), 16)
    const rChannel = (bigint >> 16) & 255
    const gChannel = (bigint >> 8) & 255
    const bChannel = bigint & 255
    return `rgb(${rChannel}, ${gChannel}, ${bChannel})`
}
